import { Card, Empty } from "antd";
import { compactAmount, fullAmount, periodLabel } from "../crmDashboardUtils";

const initials = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("") || "?";

const TopAgents = ({ data = [], currency, country, period }) => (
  <Card className="crm-card" variant="borderless">
    <div className="crm-card-head">
      <div>
        <div className="crm-card-title">Team performance</div>
        <div className="crm-card-sub">Leads and won revenue {periodLabel(period)}</div>
      </div>
    </div>

    {!data.length ? (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No team activity in this period" style={{ padding: "32px 0" }} />
    ) : (
      <div className="crm-team-scroll">
        <table className="crm-team">
          <thead>
            <tr>
              <th>Agent</th>
              <th className="num">New leads</th>
              <th className="num">Deals won</th>
              <th className="num">Revenue</th>
              <th className="num">Overdue</th>
            </tr>
          </thead>
          <tbody>
            {data.map((a, i) => (
              <tr key={a.id}>
                <td>
                  <span className="crm-team-agent">
                    <span className="crm-avatar">{initials(a.full_name)}</span>
                    <span className="crm-team-name">{a.full_name}</span>
                    {i === 0 && a.revenue > 0 && <span className="crm-chip good">Top</span>}
                  </span>
                </td>
                <td className="num">{a.leads.toLocaleString()}</td>
                <td className="num">{a.won_deals.toLocaleString()}</td>
                <td className="num" title={`${fullAmount(a.revenue)} ${currency}`}>
                  {compactAmount(a.revenue, country)} <span className="unit">{currency}</span>
                </td>
                <td className="num">
                  {a.overdue > 0 ? <span className="crm-chip bad">{a.overdue}</span> : <span className="zero">0</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </Card>
);

export default TopAgents;
